import React from "react";
import Widget from "../../../../components/Widget";
import { Col, Row } from "antd";
import style from "./style.module.scss";
import moment from "moment";
import {
    ExamListItem,
    ExamType,
    getExamTypeName
} from "../../../../service/exam";
import GoBackButton from "../goBackButton";

interface ReviewWidgetProps {
    examInfo: ExamListItem;
}

export default function ReviewWidget({ examInfo }: ReviewWidgetProps) {
    return (
        <Widget title="考核信息" bodyPadding extraTools={<GoBackButton />}>
            <Row className={style.row}>
                <Col span={8} className={style.label}>
                    考核：
                </Col>
                <Col span={16}>{examInfo.name}</Col>
            </Row>

            {[ExamType.Thesis, ExamType.Exam].includes(examInfo.type) && (
                <Row className={style.row}>
                    <Col span={8} className={style.label}>
                        时间：
                    </Col>
                    <Col span={16}>
                        {moment(examInfo.startTime).format("YYYY-MM-DD HH:mm")}{" "}
                        至
                    </Col>
                    <Col span={16} offset={8}>
                        {moment(examInfo.endTime).format("YYYY-MM-DD HH:mm")}
                    </Col>
                </Row>
            )}

            {examInfo.type === ExamType.Oral && (
                <Row className={style.row}>
                    <Col span={8} className={style.label}>
                        时间：
                    </Col>
                    <Col span={16}>
                        {moment(examInfo.startTime).format("YYYY-MM-DD")}
                    </Col>
                    <Col span={16} offset={8}>
                        {moment(examInfo.startTime).format("HH:mm")} -{" "}
                        {moment(examInfo.endTime).format("HH:mm")}
                    </Col>
                </Row>
            )}

            <Row className={style.row}>
                <Col span={8} className={style.label}>
                    方式：
                </Col>
                <Col span={16}>{getExamTypeName(examInfo.type)}</Col>
            </Row>
        </Widget>
    );
}
